import { Grid } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getOrderById } from "../../../Redux/Customers/Order/Action";
// import BackdropComponent from "../BackDrop/Backdrop";
import AddressCard from "../address/AdreessCard";

const OrderDetails = () => {
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { orderId } = useParams();
  const { order } = useSelector((store) => store);

  useEffect(() => {
    dispatch(getOrderById(orderId, jwt));
  }, []);

  const navigate = useNavigate();
  return (
    <>
      {!order.loading && (
        <div className=" px-2 lg:px-36 space-y-7 text-[#B28585] mt-7 mb-7">
          <Grid container className="p-3 shadow-md border rounded-md">
            <Grid xs={12}>
              <p className="font-bold text-lg py-2">Delivery Address</p>
            </Grid>
            <Grid item xs={6}>
              <AddressCard
                addressItem={order.order?.shippingAddress}
                deleteRequired={false}
              />
            </Grid>
          </Grid>

          <Grid container className="space-y-5">
            {order.order?.orderItems.map((item) => (
              <Grid
                container
                item
                className="shadow-md rounded-md p-5 border"
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                <Grid item xs={6}>
                  <div className="flex  items-center ">
                    <img
                      className="w-[5rem] h-[5rem] object-cover object-top"
                      src={`${item.product?.images[0]}`}
                      alt=""
                    />
                    <div className="ml-5 space-y-2">
                      <p className="font-semibold">{item.product.title}</p>
                      <p className=" text-xs font-semibold space-x-5">
                        <span>Color: {item?.product?.color}</span>{" "}
                        <span>Size: {item?.size}</span>
                      </p>
                      <p className="font-medium">Brand: {item.product.brand}</p>
                      <p className="font-medium">Qty: {item.quantity}</p>
                      <p className="font-medium">₹ {item.discountedPrice}</p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </div>
      )}
      {/* <BackdropComponent open={order.loading} /> */}
    </>
  );
};
// sx={{width:"10px",height:"10px"}}
export default OrderDetails;
